import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "@material-ui/core";

import {
  getDocumentacionPracticaSolicitud,
  getMotivosCierreInternacionDomiciliaria,
  getMotivosCierreOxigeno,
  getPracticas,
  getPracticasSolicitudSeleccionada,
  getTiposObservaciones,
  postPracticas,
} from "../../../../actions/autorizaciones/Autorizaciones";
import { getZonasEfector } from "../../../../actions/contrataciones/contratacionesCartilla";

import { AutorizacionesPractica } from "../../Ingreso/AutorizacionesPractica";
import { AutorizacionesAddPractica } from "../../Ingreso/AutorizacionesAddPractica";

import { startAlerta } from "../../../../actions/ui/alertas";
import {
  AREAS_USUARIOS,
  AUTORIZACIONES_PRACTICAS_ESTADOS,
  AUTORIZACIONES_SOLICITUDES_ESTADOS,
  PRACTICA_APERTURA_INTERNACION_DOMICILIARIA,
  PRACTICA_CIERRE_DENUNCIA_INTERNACION,
  PRACTICA_CIERRE_INTERNACION_DOMICILIARIA,
  TIPOS_AUTORIZACIONES,
} from "../../../../utils/constants";
import { ModalObservaciones } from "./ModalObservaciones";
import { ModalCierreInterDom } from "./ModalCierreInterDom";
import { AlertFinalizadoStepper } from "../../../stepper/AlertFinalizadoStepper";
import { ModalNotas } from "./ModalNotas";
import { ModalCierreOxigeno } from "./ModalCierreOxigeno";

export const PracticasMenu = (props) => {
  const dispatch = useDispatch();

  const { practicas = [], solicitudSeleccionada = {} } = useSelector((state) => state.autorizaciones);
  const { areas } = useSelector((state) => state.auth);

  const [openAgregarPractica, setOpenAgregarPractica] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [openModalCierreDenuncia, setOpenModalCierreDenuncia] = useState(false);
  const [openModalCierreInternacionDom, setOpenModalCierreInternacionDom] = useState(false);
  const [openModalCierreOxigeno, setOpenModalCierreOxigeno] = useState(false);
  const [guardarCambios, setGuardarCambios] = useState(false);
  const [openModalNota, setOpenModalNota] = useState(false);
  const [notaGuardada, setNotaGuardada] = useState(false);
  const [tituloModal, setTituloModal] = useState("");

  useEffect(() => {
    if (solicitudSeleccionada.idSolicitud) {
      dispatch(getDocumentacionPracticaSolicitud(solicitudSeleccionada.idSolicitud));
      dispatch(
        getPracticasSolicitudSeleccionada(
          solicitudSeleccionada.idSolicitud, 
          false, 
          null, 
          solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.LABORATORIO ? true : false
        )
      );
    }
  }, [solicitudSeleccionada.idSolicitud]);

  useEffect(() => {
    dispatch(getPracticas(solicitudSeleccionada.idTipoSolicitud));
    dispatch(getZonasEfector());
    solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION &&
      dispatch(getTiposObservaciones(true));
    solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
      dispatch(getMotivosCierreInternacionDomiciliaria());
      solicitudSeleccionada.idTipoSolicitud ===
      TIPOS_AUTORIZACIONES.OXIGENO &&
      dispatch(getMotivosCierreOxigeno());
  }, []);

  const evaluarPracticasMateriales = () => {
    setGuardarCambios(false);
    let faltaModificarEstadoPractica = true;
    let faltaModificarEstadoMaterial = true;
    let faltaModificarEstadoCompraPractica = true;

    if (solicitudSeleccionada.idTipoSolicitud !==
      TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS)
      faltaModificarEstadoPractica =
        (practicas.filter(s => s.idEstadoPractica ===
          AUTORIZACIONES_PRACTICAS_ESTADOS.PENDIENTE && s.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO)) ? false : true;
    else
      faltaModificarEstadoPractica = false;


    if (!faltaModificarEstadoPractica)
      faltaModificarEstadoMaterial = practicas.map((pract) => pract.materiales).filter(s => s.length > 0).length === 0 ? false : true;
    
    if (solicitudSeleccionada.idTipoSolicitud !== TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION) {
        if (!faltaModificarEstadoPractica)
          faltaModificarEstadoCompraPractica = practicas.map((pract) => pract.materiales).filter(s => s.length > 0).length === 0 ? false : true;
    
      }
    if (!faltaModificarEstadoPractica && !faltaModificarEstadoMaterial && !faltaModificarEstadoCompraPractica){
      setOpenModalConfirm(true);
    }
   
  };

  const onClickPracticasHandler = () => {
    let faltaEfectorInstitucional = false;
    let faltanPeriodosDenunciaInterDom = false;
    let faltaEfectorInstitucionalDenunciaIntDomiciliaria = false;
    let faltaEfectorInstitucionalOxigeno= false;

    let index = 0;
    while (index < practicas.length) {
      if (!faltaEfectorInstitucional)
        faltaEfectorInstitucional = !practicas[index].idCartillaPrestador;
      if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
        practicas[index].idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM) {
        if (!faltaEfectorInstitucionalDenunciaIntDomiciliaria)
          faltaEfectorInstitucionalDenunciaIntDomiciliaria = !practicas[index].idEfectorFacturacion &&
            practicas[index].idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM;
        if (!faltanPeriodosDenunciaInterDom)
          faltanPeriodosDenunciaInterDom = practicas[index].periodos?.length === 0;
      }
      if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.OXIGENO ) {
        if (!faltaEfectorInstitucionalOxigeno)
          faltaEfectorInstitucionalOxigeno = !practicas[index].idEfectorFacturacion;
      }
      index++;
    }

    if (
      (faltaEfectorInstitucional &&
        solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS &&
        solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.LABORATORIO &&
        solicitudSeleccionada.idTipoSolicitud !==
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA) ||
      (faltaEfectorInstitucionalDenunciaIntDomiciliaria &&
        solicitudSeleccionada.idTipoSolicitud ===
        TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA)
    ) {
      dispatch(
        startAlerta(
          `Los efectores institucionales no pueden quedar vacio.`,
          "error",
          "Error"
        )
      );
    } else if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
      faltanPeriodosDenunciaInterDom) {
      dispatch(
        startAlerta(
          `Todas las prácticas deben tener periodos cargados.`,
          "error",
          "Error"
        )
      );
    } else {
      const errContacto = practicas.map(
        (pr) => pr.emailEfectorIError || pr.celularEfectorIError
      );
      if (errContacto.filter((err) => err).length > 0) {
        dispatch(
          startAlerta(
            `Verifique los datos de contacto de los Efectores Institucionales.`,
            "error"
          )
        );
      } else {
        //CUANDO ES DENUNCIA_INTERNACION_DOMICILIARIA SETEO EL IdEfectorFacturacion de la practica de apertura
        let idEfectorFDeunciaIntDom = null;
        if (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA && practicas.length > 1)
          idEfectorFDeunciaIntDom = practicas[1].idEfectorFacturacion;

        const practicasFormateadas = practicas.map((practica) => {
          const materialesFormateados = practica.materiales?.map((material) => {
            return {
              idMaterial: material.idMaterial,
              cant: material.cantidad,
              autorizado: material.autorizado,
              disponible: material.disponible,
              recuperoSur: material.recuperoSur,
              idEstadoMaterial: material.idEstadoMaterial,
              idEstadoCompraMaterial: material.idEstadoCompraMaterial,
            };
          });

          let periodosFormateados;
          if(solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA || 
            solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.OXIGENO
          ){
          periodosFormateados = practica.periodos?.map((periodo) => {
            return {
              idCodNom: periodo.idCodNom,
              periodo: periodo.periodo,
              cant: periodo.cant,
              idEstadoPeriodoPractica: periodo.idEstadoPeriodoPractica,
            };
          });
          }
          return {
            idSolicitud: practica.idSolicitud,
            idCodNom: practica.idCodNom,
            cant: practica.cant,
            materiales: materialesFormateados ? materialesFormateados : [],
            periodos: periodosFormateados ? periodosFormateados : [],
            autorizada: practica.autorizada,
            recuperoSur: practica.recuperoSur,
            copiaEfectorInstitucional: practica.copiaEfectorInstitucional,
            idEfectorFacturacion: (solicitudSeleccionada.idTipoSolicitud === TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
              practica.idCodNom === PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM)
              ? idEfectorFDeunciaIntDom
              : practica.idEfectorFacturacion,
            idCartillaPrestador: practica.idCartillaPrestador,
            idPrestador: practica.idPrestador,
            idPrescriptor: practica.idPrescriptor,
            celularEfectorI: practica.celularEfectorI,
            emailEfectorI: practica.emailEfectorI,
            idTipoSolicitud: solicitudSeleccionada.idTipoSolicitud,
            idEstadoPractica: practica.idEstadoPractica,
          };
        });
        
        dispatch(
          postPracticas(
            { practicas: practicasFormateadas, finalizarSolicitud: notaGuardada && guardarCambios ? true : false },
            notaGuardada && guardarCambios ? props.onCloseModalAuditar : null,
            true,
            props.filtros
          )
        );
        
      }
    }
  };

  const permiteAgregarPracticaPeriodo = solicitudSeleccionada?.idTipoSolicitud ===
    TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
    solicitudSeleccionada?.idEstadoSolicitud ===
    AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE &&
    solicitudSeleccionada?.idTipoSolicitud ===
    TIPOS_AUTORIZACIONES.OXIGENO &&
    props.permisoIngresoInterDom;

  
  const esAreaSeccional = areas.find(area => area.idArea === AREAS_USUARIOS.AUTORIZACIONES_SECCIONAL);



  return (
    <React.Fragment>
      {openModalNota &&
        <ModalNotas
          open={openModalNota}
          close={() => {
            setOpenModalNota(false);
          }}
          // guardar={() => {
          //   dispatch(
          //     putCancelarSolicitud(
          //       idSolicitud,
          //       props.onCloseModalAuditar,
          //       true
          //     )
          //   )
          //   resetValues();
          // }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idSolicitud={solicitudSeleccionada.idSolicitud}
          disabled={false}
          titulo={tituloModal}
          privada={false}
          setNotaGuardada={setNotaGuardada}
          //nota={editNota}
          filtros={props.filtros}
        />

      }
      {openModalConfirm && (
        <AlertFinalizadoStepper
          open={openModalConfirm}
          pregunta={"Finalización de la Solicitud"}
          dialogText={"Quiere Finalizar la Solicitud al guardar cambios?"}
          buttonCancel={"No"}
          buttonSubmit={"Si"}
          handleClose={() => { setOpenModalConfirm(false); setOpenModalNota(false); }}
          handleSend={() => {
            setTituloModal("Agregar nota");
            setNotaGuardada(false);
            setOpenModalNota(true);
            setGuardarCambios(true);
            setOpenModalConfirm(false);
          }}
          filtros={props.filtros}
        />
        // <ModalConfirm
        //   open={openModalConfirm}
        //   onClose={() => {
        //     setOpenModalConfirm(false);
        //   }}
        // />
      )}
      {openModalCierreDenuncia && (
        <ModalObservaciones
          open={openModalCierreDenuncia}
          close={() => {
            setOpenModalCierreDenuncia(false);
          }}
          desdeIngresoSolicitud={props.desdeIngresoSolicitud}
          idSolicitud={solicitudSeleccionada.idSolicitud}
          onCloseModalAuditar={props.onCloseModalAuditar}
          titulo={'Cerrar Internación'}
          cierreInternacion={true}
          observacion={null}
          filtros={props.filtros}
        />
      )}
      <ModalCierreInterDom
        open={openModalCierreInternacionDom}
        close={() => {
          setOpenModalCierreInternacionDom(false);
        }}
        desdeIngresoSolicitud={props.desdeIngresoSolicitud}
        idSolicitud={solicitudSeleccionada.idSolicitud}
        onCloseModalAuditar={props.onCloseModalAuditar}
        titulo={'Cerrar Internación Domiciliaria'}
        cierreInternacion={true}
        filtros={props.filtros}
      />
      <ModalCierreOxigeno
        open={openModalCierreOxigeno}
        close={() => {
          setOpenModalCierreOxigeno(false);
        }}
        desdeIngresoSolicitud={props.desdeIngresoSolicitud}
        idSolicitud={solicitudSeleccionada.idSolicitud}
        onCloseModalAuditar={props.onCloseModalAuditar}
        titulo={'Cerrar Solicitud Oxigeno'}
        cierreInternacion={true}
        filtros={props.filtros}
      />
      <div style={{ textAlign: "center", margin: "2rem 0" }}>
        {(
          (solicitudSeleccionada?.idTipoSolicitud !== TIPOS_AUTORIZACIONES.MATERIALES_SIN_PRACTICAS
          && solicitudSeleccionada?.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA 
          && !props.disabled) 
          || ( permiteAgregarPracticaPeriodo )
        ) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenAgregarPractica(true)}
              disabled={esAreaSeccional}
            >
              + Agregar Practica
            </Button>
          )}
      </div>
      {openAgregarPractica && (
        <AutorizacionesAddPractica
          postAgregar={() => setOpenAgregarPractica(false)}
          idTipoSolicitud={solicitudSeleccionada?.idTipoSolicitud}
          permiteAgregarPracticaPeriodo={permiteAgregarPracticaPeriodo}
        />
      )}
      {Array.isArray(practicas) &&
        practicas?.length > 0 &&
        practicas//.filter(s => s.idCodNom !== PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM)
          .filter(s => s.idCodNom !== PRACTICA_CIERRE_DENUNCIA_INTERNACION.ID_COD_NOM)
          .filter(s => s.idCodNom !== PRACTICA_APERTURA_INTERNACION_DOMICILIARIA.ID_COD_NOM)
          .filter(s => s.idCodNom !== PRACTICA_CIERRE_INTERNACION_DOMICILIARIA.ID_COD_NOM)
          .map((practica, index) => {
            return (
              <AutorizacionesPractica
                key={index}
                practica={practica}
                desdeAuditar={true}
                disabled={props.disabled}
                disabledAuditar={props.disabledAuditar}
                esDenunciaInternacion={props.esDenunciaInternacion}
                conInternacion={solicitudSeleccionada.conInternacion}
                idTipoSolicitud={solicitudSeleccionada.idTipoSolicitud}
                evaluarPracticasMateriales={evaluarPracticasMateriales}
                permiteAgregarPracticaPeriodo={permiteAgregarPracticaPeriodo}
                permisoIngresoInterDom={props.permisoIngresoInterDom}
                filtros={props.filtros}
              />
            );
          })}
      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <div style={{ display: 'inline-grid' }}>
          <Button
            onClick={onClickPracticasHandler}
            disabled={props.disabled && !permiteAgregarPracticaPeriodo}
            variant="contained"
            color="primary"
          >
            Guardar Cambios
          </Button>
          {solicitudSeleccionada?.idTipoSolicitud ===
            TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION_DOMICILIARIA &&
            solicitudSeleccionada?.idEstadoSolicitud !==
            AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA &&
            <Button
              onClick={() => setOpenModalCierreInternacionDom(true)}
              disabled={props.disabled}
              style={{ marginTop: 25 }}
              variant="contained"
              color="primary"
            >
              Cerrar Internación Domiciliaria
            </Button>
          }
          {solicitudSeleccionada?.idTipoSolicitud ===
            TIPOS_AUTORIZACIONES.DENUNCIA_INTERNACION &&
            <Button
              onClick={() => setOpenModalCierreDenuncia(true)}
              style={{ marginTop: 25 }}
              disabled={props.disabled}
              variant="contained"
              color="primary"
            >
              Cerrar Internación
            </Button>
          }
            {solicitudSeleccionada?.idTipoSolicitud ===
            TIPOS_AUTORIZACIONES.OXIGENO && 
            <Button
              onClick={() => setOpenModalCierreOxigeno(true)}
              disabled={props.disabled}
              style={{ marginTop: 25 }}
              variant="contained"
              color="primary"
            >
              Cerrar 
            </Button>
          }
        </div>
      </div>
    </React.Fragment>
  );
};
